export default {"src":"/evde-internet/_next/static/media/red-loan.1034a464.svg","height":32,"width":32};